import Loading from './Loading'
import LottieLoading from './LottieLoading'

export { Loading, LottieLoading }
